<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="formMenu" ref="formMenu" class="demo-form-inline">
                <el-form-item :label="$t('common.MENU_NAME')" prop="name">
                    <td-input></td-input>
                </el-form-item>
                <el-form-item style="margin-left:100px">
                    <td-button type="primary">查询</td-button>
                    <td-button>添加</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <!-- 树形表格 -->
            <!--
                childrenName:数据源子数组名称
                hasTreeTable：是否为树形组件
                expandAll:是否全部展开
             -->
            <td-table :dataSource="data" childrenName="children" :columns="columns" :hasTreeTable="hasTreeTable" :hasIndex="hasIndex" :hasMutiSelect="hasMutiSelect" :hasPage="hasPage"></td-table>
        </el-main>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            hasTreeTable: true,
            hasIndex: true,
            hasMutiSelect: false,
            hasPage: false,
            formMenu: {},
            columns: [
                {
                    text: '菜单名称',
                    prop: 'event',
                    width: 200
                },
                {
                    text: '路径',
                    prop: 'id'
                },
                {
                    text: '排序',
                    prop: 'timeLine'
                },
                {
                    text: '描述',
                    prop: 'comment'
                },
                {
                    text: '操作',
                    value: '',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.delete(params.row.sId);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ],
            data: [
                {
                    id: '/admin/pages/boot/systemconfig.html',
                    event: '系统管理',
                    timeLine: 1,
                    comment: '系统管理',
                    children: [
                        {
                            id: '/admin/pages/boot/organization.html',
                            event: '组织管理',
                            timeLine: 1,
                            comment: '组织管理'
                        },
                        {
                            id: '/admin/pages/boot/authority.html',
                            event: '权限管理',
                            timeLine: 2,
                            comment: '权限管理'
                        }
                    ]
                },
                {
                    id: '/admin/pages/boot/equipment.html',
                    event: '设备管理',
                    timeLine: 2,
                    comment: '无',
                    children: [
                        {
                            id: '/admin/pages/boot/Coding.html',
                            event: '编码设备',
                            timeLine: 1,
                            comment: '编码设备'
                        },
                        {
                            id: '/admin/pages/boot/service.html',
                            event: '服务器设备',
                            timeLine: 2,
                            comment: '服务器设备'
                        }
                    ]
                }
            ]
        };
    },
    methods: {
        btnExit(val) {
            alert(val);
        },
        delete(val) {
            alert(val);
        }
    }
};
</script>
